import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决vue-router在3.0版本以上重复点菜单报错问题
// 缓存原本的push方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 指定新的push方法
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  // 如果指定了成功或者失败的回调
  if (onResolve || onReject) {
    // 直接调用原本的push方法
    /**
     * 不能直接调用，因为打包成为严格模式下this不是router而是undefined
     */
    // originalPush(location, onResolve, onReject)
    return originalPush.call(this, location, onResolve, onReject)
  }
  // 没有指定成功或者失败的回调，要用catch处理
  return originalPush.call(this, location).catch((err) => {
    // 如果是重复导航产生的错误，不再向外传递错误
    if (VueRouter.isNavigationFailure(err)) {
      // 产生的是成功的promise，成功的promise的value是err
      // 产生失败的promise：抛出错误或者return一个失败的promise
      return err
    }

    // 如果不是重复导航的错误，将错误向下传递
    return Promise.reject(err)
  })
}

VueRouter.prototype.replace = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const routes = [
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */'@/views/home/home-page.vue')
  },
  {
    path: '/commonModule/search',
    name: 'search',
    component: () => import('@/views/search/search-page.vue'),
    meta: { title: '搜索结果页', breadcrumb: true }
  },
  {
    path: '/detail/entity/:entityId',
    name: 'entity',
    component: () => import('@/views/detail/entity-detail-page.vue'),
    meta: { title: '帖子详情页', breadcrumb: true }
  },
  {
    path: '/detail/company/:companyId',
    name: 'company',
    component: () => import('@/views/detail/company-detail-page.vue'),
    meta: { title: '企业详情页', breadcrumb: true }
  },
  {
    path: '/loginAndRegister/loginAndRegister/',
    name: 'loginAndRegister',
    component: () => import('@/views/loginAndRegister/loginAndRegister-page.vue'),
    meta: { title: '登录注册页', breadcrumb: true }
  },
  {
    path: '/commonModule/personal',
    name: 'personal',
    component: () => import('@/views/personal/personal-page.vue'),
    children: [
      {
        path: 'binding',
        name: 'binding',
        component: () => import('@/views/personal/modules/personal-company-binding.vue')
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/personal/modules/personal-result-profile.vue')
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@/views/personal/modules/personal-result-history.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/personal/modules/personal-result-about.vue')
      },
      {
        path: '',
        redirect: 'profile'
      }
    ]
  },
  {
    path: '/commonModule/release',
    name: 'release',
    component: () => import('@/views/release/release-page.vue')
  },
  {
    path: '/releaseModule/hire',
    name: 'HireModule ',
    component: () => import('@/views/release/modules/hire-module.vue')
  },
  {
    path: '/releaseModule/real-estate',
    name: 'RealEstateModule',
    component: () => import('@/views/release/modules/real-estate-module.vue')
  },
  {
    path: '/releaseModule/second-hand',
    name: 'SecondHandModule',
    component: () => import('@/views/release/modules/second-hand-module.vue')
  },
  {
    path: '/releaseModule/local-life',
    name: 'LocalLifeModule ',
    component: () => import('@/views/release/modules/local-life-module.vue')
  },
  {
    path: '/releaseModule/urgent-sale',
    name: 'UrgentSaleModule',
    component: () => import('@/views/release/modules/urgent-sale-module.vue')
  },
  {
    path: '/releaseModule/seek-employment',
    name: 'SeekEmploymentModule ',
    component: () => import('@/views/release/modules/seek-employment-module.vue')
  }

]

const router = new VueRouter({
  routes
})

export default router
